var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeOut = function SvgTimeOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.917 14.167h-2.334v-2.334a1.166 1.166 0 1 0-2.333 0v3.5c0 .646.523 1.167 1.167 1.167h3.5a1.166 1.166 0 1 0 0-2.333ZM11 22.042c-4.342 0-7.875-3.533-7.875-7.875 0-4.343 3.533-7.875 7.875-7.875 4.342 0 7.875 3.532 7.875 7.875 0 4.342-3.533 7.875-7.875 7.875Zm1.153-18.308c.002-.024.014-.043.014-.067V2.5h1.166a1.166 1.166 0 1 0 0-2.333H8.667a1.166 1.166 0 1 0 0 2.333h1.166v1.167c0 .024.012.043.014.067C4.6 4.311.5 8.767.5 14.167c0 5.79 4.711 10.5 10.5 10.5s10.5-4.71 10.5-10.5c0-5.4-4.099-9.856-9.347-10.433Z",
    fill: "#F3A800"
  })));
};
export default SvgTimeOut;